import { Inject, Injectable, PLATFORM_ID, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from '../../_validators/custom.validators';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class FormService {
  private fb = inject(FormBuilder);

  constructor(@Inject(PLATFORM_ID) private platformId: any) {}

  createRegisterForm(): FormGroup | null {
     if (!isPlatformBrowser(this.platformId)) {
      return null;
    }
    return this.fb.group({
      //username: ['', [Validators.required, CustomValidators.username]],
      firstName: ['', [Validators.required, Validators.maxLength(100)]],
      lastName: ['', [Validators.required, Validators.maxLength(100)]],
      email: ['', [Validators.required, CustomValidators.email]],
      phoneNumber: ['', [Validators.required, CustomValidators.phone]],
      password: ['', [Validators.required, CustomValidators.password]],
      confirmPassword: ['', [Validators.required]],
      address: this.fb.group({
        street: [''],
        city: [''],
        state: [''],
        zipCode: [''],
        country: ['']
      })
    }, {
      validators: CustomValidators.match('password', 'confirmPassword')
    });
  }

  markFormGroupTouched(formGroup: FormGroup): void {
    if (!formGroup) return;
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      } else {
        control?.markAsTouched();
      }
    });
  }

  getFormErrors(formGroup: FormGroup): { [key: string]: string } {
    const errors: { [key: string]: string } = {};
    
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (control instanceof FormGroup) {
        Object.assign(errors, this.getFormErrors(control));
      } else if (control?.errors && control.touched) {
        const firstError = Object.keys(control.errors)[0];
        errors[key] = control.errors[firstError];
      }
    });

    return errors;
  }
}